import React from 'react';
import Home from '../../Components/Home'

const HomeScreen = () => {
  return <div>
  <Home />
  </div>;
};

export default HomeScreen;
